import React, { Fragment } from 'react';
import PageNotFound from '../../components/auth/PageNotFound';

const PageNotFoundView = () => {
  return (
    <Fragment>
        <PageNotFound />
    </Fragment>
  )
}

export default PageNotFoundView